<template>
  <div class="insurance-list-container">
    <div class="card-container">
      <!-- 查询区域：添加多个查询条件 -->
      <div class="query-section">
        <!-- 订单编号 -->
        <div class="query-item">
          <span class="query-label">订单编号</span>
          <el-input
            v-model="orderNo"
            placeholder="请输入订单编号"
            style="width: 100%; max-width: 220px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 投保单号 -->
        <div class="query-item">
          <span class="query-label">投保单号</span>
          <el-input
            v-model="insuredNo"
            placeholder="请输入投保单号"
            style="width: 100%; max-width: 220px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 投保人名称 -->
        <div class="query-item">
          <span class="query-label">投保人名称</span>
          <el-input
            v-model="appliRealName"
            placeholder="请输入投保人名称"
            style="width: 100%; max-width: 200px;"
            clearable
          >
          </el-input>
        </div>

        <!-- 投保时间范围 -->
        <div class="query-item">
          <span class="query-label">投保时间</span>
          <el-date-picker
            v-model="createTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%; max-width: 300px;"
            clearable
            class="date-picker-custom"
          >
          </el-date-picker>
        </div>

        <!-- 生效日期范围 -->
        <div class="query-item">
          <span class="query-label">生效日期</span>
          <el-date-picker
            v-model="beginTimeRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%; max-width: 300px;"
            clearable
          >
          </el-date-picker>
        </div>

        <div class="query-item query-buttons">
          <el-button type="primary" @click="query" class="query-button">
            <i class="el-icon-search"></i> 查询
          </el-button>

          <el-button type="default" @click="resetQuery" class="reset-button">
            <i class="el-icon-refresh"></i> 重置
          </el-button>
        </div>
      </div>

      <!-- 列表区域 -->
      <el-table
        v-loading="loading"
        :loading-text="'正在加载数据...'"
        :data="insuranceList"
        style="width: 100%;"
        border
        class="insurance-table"
        stripe
        highlight-current-row
      >
        <el-table-column prop="orderNo" label="订单编号"></el-table-column>
        <el-table-column prop="createTime" width="200" label="投保时间"></el-table-column>
        <el-table-column prop="beginTime" width="150" label="保单生效日期"></el-table-column>
        <el-table-column prop="endTime" width="150" label="保单结束时间"></el-table-column>
        <el-table-column prop="appliRealName" label="投保人名称"></el-table-column>
        <el-table-column prop="insuredNo" label="投保单号"></el-table-column>
        <el-table-column prop="pcPayUrl" width="150" label="复制支付链接">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-document-copy"
              @click="copyPaymentLink(resultEICurl(scope.row.productId)+scope.row.id)"
              :disabled="!(resultEICurl(scope.row.productId) + scope.row.id)"
            >
              复制链接
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="confirmationAddress" width="150" label="下载确认书">
          <template slot-scope="scope">
            <a
              v-if="scope.row.confirmationAddress"
              :href="scope.row.confirmationAddress"
              class="download-link"
              download
              target="_blank"
            >
              下载确认书
            </a>
            <span v-else>无</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <div class="pagination-section">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {service, resultEICurlHead} from '../../utils/axios'
import {getToken} from '../../utils/auth'

export default {
  name: 'anDeEICOrderList',
  data () {
    return {
      // 查询参数
      orderNo: '', // 订单编号
      insuredNo: '', // 投保单号
      appliRealName: '', // 投保人名称
      createTimeRange: [], // 投保时间范围 [开始日期, 结束日期]
      beginTimeRange: [], // 生效日期范围 [开始日期, 结束日期]
      loading: false, // 添加加载状态标记
      insuranceList: [], // 投保列表数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页条数
      total: 0 // 总条数
    }
  },
  methods: {
    resultEICurl (productId) {
      console.log(resultEICurlHead)
      console.log(productId)
      // ['1948587488204410881', '1948587557053911042', '1948587670757298177', '1948587609948278786'],
      if (productId === '1948587488204410881' || productId === '1948587670757298177') {
        return resultEICurlHead + 'resultEICSuppSum?id=' // 内嵌页面的URL
      } else {
        return resultEICurlHead + 'resultEIC?id='
      }
    },
    // 获取投保列表数据
    async fetchInsuranceList () {
      this.loading = true // 开始加载
      // TODO: 对接后端接口
      try {
        console.log(this.createTimeRange)
        const params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize,
          productId: ['1948587488204410881', '1948587557053911042', '1948587670757298177', '1948587609948278786'],
          orderNo: this.orderNo,
          insuredNo: this.insuredNo,
          appliRealName: this.appliRealName,
          // 修复：判断数组存在且有元素，否则传空字符串（避免访问null[0]）
          createTimeBegin: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[0] : '',
          createTimeEnd: this.createTimeRange && this.createTimeRange.length > 0 ? this.createTimeRange[1] : '',
          beginTimeBegin: this.beginTimeRange && this.beginTimeRange.length > 0 ? this.beginTimeRange[0] : '',
          beginTimeEnd: this.beginTimeRange && this.beginTimeRange.length > 0 ? this.beginTimeRange[1] : ''
        }
        const res = await service.get('/Order/insuranceOrder/anDeEICListNew', {
          params: params, // 将参数正确放入params属性
          headers: {
            'x-access-token': getToken() || '' // 确保token存在
          },
          timeout: 100000
        })
        console.log(res.result)
        if (res.success) {
          console.log(res.result)
          this.insuranceList = res.result.records
          this.total = res.result.total
        } else {
          this.$message.error('数据获取失败')
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$message.error('登录过期，请重新登录')
          this.$router.push({path: '/login'})
        }
        console.error('接口请求异常:', error)
        this.$message.error('数据加载失败')
      } finally {
        this.loading = false // 结束加载，无论成功失败
      }
    },
    query () {
      this.currentPage = 1 // 当前页码
      this.fetchInsuranceList()
    },
    copyPaymentLink (url) {
      if (!url) {
        this.$message.warning('支付链接不存在')
        return
      }

      // 使用浏览器剪贴板API复制链接
      navigator.clipboard.writeText(url)
        .then(() => {
          this.$message.success('支付链接已成功复制到剪贴板')
        })
        .catch(() => {
          // 兼容处理：创建临时文本区域复制
          const textarea = document.createElement('textarea')
          textarea.value = url
          document.body.appendChild(textarea)
          textarea.select()
          document.execCommand('copy')
          document.body.removeChild(textarea)
          this.$message.success('支付链接已成功复制到剪贴板')
        })
    },
    // 重置查询条件
    resetQuery () {
      this.orderNo = ''
      this.insuredNo = ''
      this.appliRealName = ''
      this.createTimeRange = []
      this.beginTimeRange = []
      this.currentPage = 1
    },
    // 每页条数变化
    handleSizeChange (val) {
      this.pageSize = val
      this.fetchInsuranceList()
    },
    // 当前页码变化
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchInsuranceList()
    }
  },
  created () {
    // 页面加载时获取列表数据
    this.fetchInsuranceList()
  }
}
</script>

<style scoped>
.insurance-list-container {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.card-container {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.query-button {
  height: 40px;
}

.insurance-table {
  margin-bottom: 20px;
  border-radius: 6px;
  overflow: hidden;
}

.insurance-table /deep/ .el-table__row:hover {
  background-color: #f5f7fa;
}

.insurance-table /deep/ .el-table th {
  background-color: #f5f7fa;
  font-weight: 500;
}

.pagination-section {
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;
}

.download-link {
  color: #409EFF;
  text-decoration: none;
}

.download-link:hover {
  text-decoration: underline;
}

/* 修复日期选择器prepend插槽文字不显示 */
.date-picker-custom {
  /* 确保输入框内部有足够空间容纳prepend标签 */

  .el-input__prepend {
    background: #f5f7fa; /* 与查询区域背景协调，避免文字颜色与背景一致 */
    border-right: 1px solid #dcdfe6; /* 分隔标签和输入区域，视觉更清晰 */
    padding: 0 12px; /* 增加标签内边距，避免文字挤在一起 */
  }

  /* 确保占位符显示正常 */

  .el-input__inner {
    padding: 0 12px; /* 输入框内边距，避免占位符被遮挡 */
  }
}

/* 防止查询区域flex布局挤压组件 */
.query-section {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 15px;
  background-color: #f9fafc;
  border-radius: 6px;
  gap: 10px; /* 增加组件间距，避免挤压 */
  min-height: 60px; /* 给查询区域最小高度，防止组件被压缩 */
}

.query-section {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
  align-items: center;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}

.query-item {
  display: flex;
  align-items: center;
}

.query-label {
  width: 80px;
  text-align: right;
  margin-right: 8px;
  color: #606266;
  font-size: 14px;
}

.query-buttons {
  margin-left: auto;
  display: flex;
  gap: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/anDeEIC/anDeEICOrderList.vue